import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = {
  display: 'flex',
  gap: '12px',
  alignItems: 'center'
};

const primaryButton: SxProps<Theme> = {
  minWidth: '180px'
};

const outlinedButton: SxProps<Theme> = {
  minWidth: '140px',
  borderColor: 'primary.main',
  color: 'primary.main'
};

const textButton: SxProps<Theme> = {
  color: 'primary.main'
};

export const openingMessagesLaunchButtonsSx = {
  container,
  primaryButton,
  outlinedButton,
  textButton
};
